import type { ReactNode } from 'react'
import { Mic, MessageCircleMore, Monitor, Sparkles } from 'lucide-react'
import type { ReminderSource } from '@renderer/overlay/Sidepanel/hooks/use-reminders'

/** Small attribution icon shown next to the source label on a reminder's source row. */
export function getSourceIcon(type: ReminderSource['type']): ReactNode {
  switch (type) {
    case 'audioNote':
      return <Mic size={12} />
    case 'conversation':
      return <MessageCircleMore size={12} />
    case 'screen':
      return <Monitor size={12} />
    case 'dailySummary':
    case 'insight':
    default:
      return <Sparkles size={12} />
  }
}
